import { printerApi } from '../../api';
import { PrinterRegistrationForm } from '../../types/hardware/PrinterTypes';

const PrinterService = {
  /**
   * Lista todas las impresoras registradas.
   * GET /api/printers
   */
  getAll: async () => {
    const response = await printerApi.fetchAll();
    return response.data;
  },

  /**
   * Obtiene una impresora por su ID.
   * GET /api/printers/{id}
   */
  findById: async (id: number) => {
    const response = await printerApi.fetchById(id);
    return response.data;
  },

  /**
   * Registra una nueva impresora térmica.
   * POST /api/printers
   */
  create: async (data: PrinterRegistrationForm) => {
    const response = await printerApi.add(data);
    return response.data;
  },

  /**
   * Actualiza una impresora térmica existente.
   * PUT /api/printers/{id}
   */
  update: async (id: number, data: PrinterRegistrationForm) => {
    const response = await printerApi.modify(id, data);
    return response.data;
  },

  /**
   * Activa o desactiva una impresora.
   * PATCH /api/printers/{id}/toggle
   */
  toggleStatus: async (id: number) => {
    const response = await printerApi.patchCustom(`${id}/toggle`);
    return response.data;
  },
};

export default PrinterService;
